export default __webpack_public_path__ + "static/fintech-8d162edd239e56bf5ad375c7c75db3ba.jpg";